import { ReactNode } from 'react'
import * as React from 'react'
type Props = {
  children?: ReactNode
  color?: string
  width?: string
  height?: string
}

const CartIcon: React.FunctionComponent<Props> = (props) => {
  const { width, height, color } = props

  return (
    // <svg
    //   width={width ? width : '100%'}
    //   height={height ? height : '100%'}
    //   viewBox="0 0 401 350"
    //   version="1.1"
    // >
    //   <g
    //     id="shopping-basket-button"
    //     fill={color ? color : '#1A1E3D'}
    //     fillRule="nonzero"
    //   >
    //     <g id="Shape">
    //       <path d="M298.202624,128.272251 L217.46868,7.32984293 C213.798235,3.66492147 208.294368,0 202.78978,0 C197.285193,0 191.780606,1.83246073 188.110881,7.32984293 L107.376936,128.272251 L19.3035419,128.272251 C8.29436757,128.272251 0.954918033,135.602094 0.954918033,146.596859 C0.954918033,148.429319 0.954918033,150.26178 0.954918033,152.094241 L46.8264777,322.513089 C50.4962024,337.172775 65.1751015,350 81.688863,350 L320.220973,350 C336.734735,350 351.413634,339.005236 355.083358,322.513089 L400.954918,152.094241 C400.954918,150.26178 400.954918,148.429319 400.954918,146.596859 C400.954918,135.602094 393.615468,128.272251 382.606294,128.272251 L298.202624,128.272251 Z M147.743909,128.272251 L202.78978,47.6439791 L257.835652,128.272251 L147.743909,128.272251 Z M202.78978,274.86911 C182.606294,274.86911 166.092533,258.376963 166.092533,238.219895 C166.092533,218.062827 182.606294,201.570681 202.78978,201.570681 C222.973267,201.570681 239.487028,218.062827 239.487028,238.219895 C239.487028,258.376963 222.973267,274.86911 202.78978,274.86911 Z"></path>
    //     </g>
    //   </g>
    // </svg>
    <svg
      width={width ? width : '21'}
      height={height ? height : '18'}
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6174 6.59686L11.3894 0.376963C11.1972 0.188482 10.909 0 10.6207 0C10.3324 0 10.0441 0.0942408 9.85196 0.376963L5.624 6.59686H1.01168C0.435141 6.59686 0.0507812 6.97382 0.0507812 7.53927V7.82199L2.45303 16.5864C2.64521 17.3403 3.41393 18 4.27874 18H16.7704C17.6353 18 18.404 17.4346 18.5962 16.5864L20.9984 7.82199V7.53927C20.9984 6.97382 20.614 6.59686 20.0375 6.59686H15.6174ZM7.73798 6.59686L10.6207 2.45026L13.5034 6.59686H7.73798ZM8.69889 12.2513C8.69889 13.288 9.5637 14.1361 10.6207 14.1361C11.6777 14.1361 12.5425 13.288 12.5425 12.2513C12.5425 11.2147 11.6777 10.3665 10.6207 10.3665C9.5637 10.3665 8.69889 11.2147 8.69889 12.2513Z"
        fill={color ? color : '#1A1E3D'}
      />
    </svg>
  )
}

export default CartIcon
